import { StyledLayout } from "./Layout.styles";
import Prism from "prismjs";
import PrismJsx from "prismjs/components/prism-jsx.min";
import "../../Prism/prism.css";
import Navbar from "../Navbar/Navbar";
import CardContainer from "../CardContainer/CardContainer";
import { useEffect } from "react";

const s =
  'import { StyledCards } from "./Cards.styles";' +
  "\n" +
  "" +
  "\n" +
  "const Cards = (props) => {" +
  "\n" +
  "    return (" +
  "\n" +
  '        <StyledCards href={`http://mdl.marinasystem.intelletech.co.uk/index.html?marina=${props.href}`} target="_blank" onClick={props.onClick}>' +
  "\n" +
  '                <div className="marina">' +
  "\n" +
  '                    <div className="marinaImage">' +
  "\n" +
  "                    <img src={`/images/${props.image}`} alt={`${props.marina} Marina`}/>" +
  "\n" +
  "                    </div>" +
  "\n" +
  "                    <p>{props.marina}</p>" +
  "\n" +
  "                </div>" +
  "\n" +
  "        </StyledCards>" +
  "\n" +
  "    )" +
  "\n" +
  "}" +
  "\n" +
  "" +
  "\n" +
  "export default Cards";
const Layout = () => {
  // useEffect(() => {
  //     Prism.highlightAll();
  // }, [])
  return (
    <StyledLayout>
      <Navbar />
      <CardContainer />
      {/* <pre>
                <code className="language-jsx">{s}</code>
            </pre> */}
    </StyledLayout>
  );
};

export default Layout;
